import { ReactNode } from "react";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../core/et3-div";

const FormSectionWrapper = withLiteObserverAndTheme<{ children: ReactNode }>(
  (props) => {
    const { children } = props;

    return (
      <ET3Div
        width={1510}
        height={100}
        alignItems={"flex-start"}
        fDirection={"row"}
        style={{
          flexWrap: "wrap",
          columnGap: 50,
          paddingBottom: 10
        }}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => { }}
      >
        {children}
      </ET3Div>
    );
  }
);

export default FormSectionWrapper;
